<div class="container-fluid">

  <!-- Barra di ricerca estesa -->
  <div style="margin-top: 24px;">
    <app-subject-extended-search
      [service]="subjectService"
      [showAdvancedSearch]="true"
      (selected)="goTo($event)"
      (clearOut)="clearSearch()"
      (resultsLoaded)="onSearchResultsLoaded($event)">
    </app-subject-extended-search>
  </div>

  <div style="overflow-x: auto;">

    <app-data-table-with-pagination [data]="dataSource" [columns]="columns" [displayedColumns]="displayedColumns"
      [actions]="actions" [totalRows]="totalRows" [pageInit]="pageInit" [currentPage]="currentPage"
      [clientSidePagination]="isClientSidePagination"
      (changePagination)="pageChanged($event)" (changeOrder)="updateDataBySortParams($event)"
      sortActive=""></app-data-table-with-pagination>

  </div>

</div>